import { getTabTitle } from '../../../../../util/tab-util';
import TabIcon from '../TabIcon';
import type { MenuTabProps } from '../types';
import { getTabClasses } from '../utils';

const MenuTab = ({ tab, activeTabId, onClick }: MenuTabProps) => {
  const isActiveTab = tab.id === activeTabId;
  const tabTitle = getTabTitle(tab);

  return (
    <button
      type="button"
      className={`${getTabClasses(isActiveTab)} justify-between w-[200px] rounded-md`}
      onClick={() => onClick(tab.id)}
      data-testid="global-tab-menu-item"
    >
      <span className="flex items-center justify-center shrink-0 w-6 h-6">
        <TabIcon tab={tab} />
      </span>
      <span className="me-auto truncate">{tabTitle}</span>
    </button>
  );
};

export default MenuTab;
